export type Title = 'Mr' | 'Mrs' | 'Miss' | 'Ms' | 'Dr (Female)' | 'Dr (Male)';

export const titles: Title[] = ['Mr', 'Mrs', 'Miss', 'Ms', 'Dr (Female)', 'Dr (Male)'];
